export const blockIconsPlacesKitchen = (
	<span className='material-symbols-outlined'>kitchen</span>
);
